import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=27f6ff3a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f6ff3a')) {
      api.createRecord('27f6ff3a', component.options)
    } else {
      api.reload('27f6ff3a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=27f6ff3a&", function () {
      api.rerender('27f6ff3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hFCXK7G64gei/JS/offershelp.vue"
export default component.exports